export default __webpack_public_path__ + "static/media/lessons_button.53fc7d92.png";